import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { registerCoreModules } from './modules';
import { AuthProvider } from './modules/auth';
import { createAppRouter } from './router';
import { ThemeProvider } from './theme';
import './pwa/reloadOnControllerChange';
import './index.css';

registerCoreModules();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root container missing from index.html');
}

// `ThemeProvider` sits above everything so the theme (including live system-preference
// updates) applies on every route, public ones included — not just while Settings is
// mounted. `AuthProvider` sits above the router so `RequireAuth` (and any page) can read the
// session on every route; the router itself decides which routes are public (see router.tsx).
createRoot(container).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={createAppRouter()} />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
